// import './region-menu';
(function( $ ){
	$(document).ready(function(){
		var lciCollection = window.region_lci_collection;
		if ( !_.isEmpty(lciCollection) ) {


			var render_table = function( items ){
				var lciTable = $( '#region-lci-table' );
				lciTable.html( '' );
				if ( items.length ) {
					$.each( items, function(){
						var row = row_template( this );
						lciTable.append( row );
					} );
				} else {
					lciTable.html( '<tr><td class="text-center" colspan="3">No partners found.</td></tr>' );
				}
			};


			var filter_table = function(){
				var filterProps = {};
				$( '.lci-filter' ).each(function(){
					var val = $(this).val();
					var prop = $(this).data( 'facet' );
					if ( val ) {
						filterProps[prop] = val;
					}
				});
				if ( Object.keys(filterProps).length === 0 ) {
					render_table( lciCollection );
				} else {
					var filteredItems = _.filter( lciCollection, function( item ){
						if ( filterProps.country ) {
							if ( item.country !== filterProps.country ) {
								return false;
							}
						}
						if ( filterProps.activities ) {
							if ( ! _.contains( item.activities, filterProps.activities ) ) {
								return false;
							}
						}
						return true;
					});
					render_table( filteredItems );
				}
			};


			const countries = _.uniq( _.pluck( lciCollection, 'country' ) );
			const activities = _.uniq( _.flatten( _.pluck( lciCollection, 'activities' ) ) );
			

			// add options to dropdowns
			$.each( countries, function(){
				var opt = document.createElement("option");
				opt.value = this;
				opt.text = this;
				$( '#country-filter' ).append( opt )
			} );

			$.each( activities, function(){
				var opt = document.createElement("option");
				opt.value = this;
				opt.text = this;
				$( '#activities-filter' ).append( opt )
			} );


			// add events to dropdown changes
			$( '.lci-filter' ).on( 'change', filter_table );
			var row_template = _.template( $( '#lci-row-template' ).html() );

			// render table
			render_table( lciCollection );

		}
	});
})(jQuery)